import React, { useState } from "react";
import "./Address_cards.css";
import { Row, Col, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Delete_Modal from "../../../components/Common-Component/Commonmodal/Delete_Modal/Delete_Modal";

function Address_cards({
  value,
  setBillingAddress,
  setError,
  billingAddrress,
  radio_status,
  getAllData,
}) {
  const navigate = useNavigate();

  const handleRadioChange = (val) => {
    setError("");
    setBillingAddress(val);
  };
  const [modalDeleteShow, setDeleteModalShow] = useState(false);
  
  const handleDelete = async () => {
    setDeleteModalShow(true);
  };
  return (
    <>
      <section className="Address_cards">
        <div className="custom_container">
          <div className="address_card">
            <Row className="align-items-start g-0">
              {/* LEFT MAP */}
              <Col xs="auto">
                <div className="map_holder">
                  <div className="embed-map-container">
                    <iframe
                      className="embed-map-frame"
                      frameBorder="0"
                      scrolling="no"
                      marginHeight="0"
                      marginWidth="0"
                      src="https://maps.google.com/maps?width=600&height=400&hl=en&q=pune&t=&z=14&ie=UTF8&iwloc=B&output=embed"
                      title="map"
                    ></iframe>
                  </div>

                  {/* PIN ICON */}
                  <div className="location_pin">
                    <img
                      src="/assest/luxury_images/icon/location_pin.png"
                      alt="pin"
                      className="pin_img"
                    />
                  </div>
                </div>
              </Col>

              {/* CENTER TEXT */}
              <Col>
                <div className="address_text">
                  <h6 className="address_type">{value?.address_type}</h6>
                  <h5 className="person_name">
                    {value?.f_name} {value?.l_name}
                  </h5>
                  <p className="full_address">
                    {value?.location}, {value?.company}, {value?.address},{" "}
                    {value?.city?.name}, {value?.state?.name},{" "}
                    {value?.country?.name} - {value?.pincode?.name}
                  </p>
                  <div className="delete_icon_holder">
                    <FontAwesomeIcon
                      icon={faTrash}
                      onClick={() => handleDelete(value?.id)}
                    />
                  </div>
                </div>
              </Col>

              {/* RIGHT RADIO */}
              {!radio_status && (
                <Col xs="auto">
                  <Form.Group className="mb-3" controlId="formBasicCheckbox">
                    <Form.Check
                      name="address"
                      type="radio"
                      checked={billingAddrress?.id === value?.id}
                      onChange={() => handleRadioChange(value)}
                    />
                  </Form.Group>
                </Col>
              )}
            </Row>

            {/* EDIT */}
            <div className="edit_holder">
              <button
                className="edit_btn"
                onClick={() => navigate(`/luxury/edit-address/${value?.id}`)}
              >
                Edit
              </button>
            </div>
          </div>
        </div>
        <Delete_Modal
          text={"Are you sure you want to delete address?"}
          getAllData={getAllData}
          deleteID={value?.id}
          show={modalDeleteShow}
          onHide={() => setDeleteModalShow(false)}
        />
      </section>
    </>
  );
}

export default Address_cards;
